import { OAuthConfig } from '@over-c/web-client-auth/lib/cjs';

export const authConfig: OAuthConfig = {
  client_id: 'overc-web-home',
  requested_scopes: 'WEB',
};
